import React from "react";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import reportConstants from "../constants";
import { utcToZonedTime } from "date-fns-tz";
import { withSnackbar } from "notistack";
import MESSAGES from "../../../../../appMessages";
import DriverPerformanceRenderer from "../components/ReportRenderer";
import { populateFormattedData, populateLinks } from "../util";
import { addDays, format, differenceInCalendarDays } from "date-fns";
import { sortBy } from "lodash";
import constants from "./constants";
import { withAppConfig } from "../../../../../appConfigContext";
class DriverPerformanceHistoric extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      isLoading: false,
    };
  }

  componentDidMount() {
    this.getDriverPerformanceData();
  }

  getTerminalDateTime = () => {
    return utcToZonedTime(
      new Date(),
      this.props.userData.userProfile.terminal.offset
    );
  };

  getCurrentDispatchDate = () => {
    return format(this.getTerminalDateTime(), reportConstants.APP_DATE_FORMAT);
  };

  handleError = () => {
    this.props.enqueueSnackbar(MESSAGES.DRIVER_PERFORMANCE.FETCH_DATA_FAILURE, {
      variant: "error",
    });
    this.setState({
      isLoading: false,
      data: null,
    });
  };

  getRequestParamsByReportType = () => {
    const {
      selectedFilterData: {
        driver,
        dispatchDate,
        startDate,
        endDate,
        terminalCode,
      },
    } = this.props;
    if (this.props.reportType === reportConstants.REPORT_TYPES.TERMINAL) {
      return `terminalCode=${terminalCode}&startDate=${dispatchDate}&endDate=${dispatchDate}`;
    }
    return `driverNumber=${driver}&startDate=${startDate}&endDate=${endDate}`;
  };

  getReportDateRange = () => {
    if (this.props.reportType === reportConstants.REPORT_TYPES.TERMINAL) {
      return {
        startDate: this.props.selectedFilterData.dispatchDate,
        endDate: this.props.selectedFilterData.dispatchDate,
      };
    }
    const currentDate = format(new Date(), reportConstants.APP_DATE_FORMAT);
    return {
      startDate: currentDate,
      endDate: currentDate,
    };
  };

  getDriverPerformanceData = () => {
    this.setState({ isLoading: true, data: null });
    getDataWithQueryString(
      "DriverPerformanceHistoricData",
      this.getRequestParamsByReportType()
    ).then(
      ({ status, data }) => {
        if (status && status >= 200 && status <= 400) {
          if (
            data &&
            this.props.reportType === reportConstants.REPORT_TYPES.DRIVER
          ) {
            // if search by driver option is selected , tranform all date fields in API response to reflect current date.
            data = this.transformData(sortBy(data, "dispatchDate"));
          }
          this.initializeReportData(data);
        } else {
          this.handleError();
        }
      },
      () => {
        this.handleError();
      }
    );
  };

  getTransformedDate = (dispatchDate, requiredDate, date) => {
    if (date) {
      const formattedDate = format(date, reportConstants.APP_DATE_FORMAT);
      const diff1 = differenceInCalendarDays(formattedDate, dispatchDate); // difference in days between actual date time value and dispatch date in API.
      const diff2 = differenceInCalendarDays(requiredDate, formattedDate); //difference in days between actual date time value and required reference date to which actual date should be tansformed to.
      return format(addDays(date, diff1 + diff2), "yyyy-MM-dd HH:mm:ss");
    }
    return null;
  };

  transformStopsData = (stops, dispatchDate, requiredDispatchDate) => {
    return this.transformListData({
      list: stops,
      fieldListToTransform: constants.STOP_FIELDS_TO_TRANSFORM_LIST,
      dispatchDate: dispatchDate,
      requiredDispatchDate,
    });
  };

  transformListData = ({
    list,
    fieldListToTransform,
    dispatchDate,
    requiredDispatchDate,
  }) => {
    return list.map((listItem) => {
      fieldListToTransform.map((field) => {
        Object.keys(listItem).forEach((key) => {
          if (key === field) {
            listItem[key] = this.getTransformedDate(
              dispatchDate,
              requiredDispatchDate,
              listItem[key]
            );
          }
        });
      });
      return listItem;
    });
  };

  transformRouteData = (routes, dispatchDate, requiredDispatchDate) => {
    const transformedRoutes = this.transformListData({
      list: routes,
      fieldListToTransform: constants.ROUTE_FIELDS_TO_TRANSFORM_LIST,
      dispatchDate: dispatchDate,
      requiredDispatchDate,
    });
    return transformedRoutes.map((route) => {
      return {
        ...route,
        stops: this.transformStopsData(
          route.stops,
          dispatchDate,
          requiredDispatchDate
        ),
      };
    });
  };

  transformData = (data) => {
    const requiredDispatchDate = format(
      new Date(),
      reportConstants.APP_DATE_FORMAT
    ); // using current date as reference date to which all date time fields in API response will be tranformed to.
    return data.map((driver) => {
      return {
        ...driver,
        driverClockedInTime: this.getTransformedDate(
          driver.dispatchDate,
          requiredDispatchDate,
          driver.driverClockedInTime
        ),
        driverClockedOutTime: this.getTransformedDate(
          driver.dispatchDate,
          requiredDispatchDate,
          driver.driverClockedOutTime
        ),
        routes: this.transformRouteData(
          driver.routes,
          driver.dispatchDate,
          requiredDispatchDate
        ),
      };
    });
  };

  getFormattedReportData = (data) => {
    const { reportType, selectedFilterData } = this.props;
    const formattedData = populateFormattedData({
      driversData: data,
      dispatchDate:
        reportType === reportConstants.REPORT_TYPES.DRIVER
          ? format(new Date(), reportConstants.APP_DATE_FORMAT)
          : selectedFilterData.dispatchDate,
      showTrailerScac: this.props.configJSON.showTrailerScac,
    });
    const links = populateLinks(formattedData);
    return {
      tasks: formattedData,
      links: links,
    };
  };

  initializeReportData = (responseData) => {
    const data = responseData ? responseData : null;
    this.setState({
      data,
      formattedFilteredData: data ? this.getFormattedReportData(data) : null,
      isLoading: false,
    });
  };

  updateFilteredData = (filteredData) => {
    this.setState({
      formattedFilteredData: this.getFormattedReportData(filteredData),
    });
  };

  render() {
    const { isLoading, data, formattedFilteredData } = this.state;
    const { startDate, endDate } = this.getReportDateRange();
    const { reportType, selectedFilterData } = this.props;
    return (
      <React.Fragment>
        <DriverPerformanceRenderer
          isLoading={isLoading}
          data={data}
          isDataRefreshed={false}
          currentDispatchDate={this.getCurrentDispatchDate()}
          goBack={this.props.goBack}
          updateFilteredData={this.updateFilteredData}
          formattedFilteredData={formattedFilteredData}
          startDate={startDate}
          endDate={endDate}
          showBackButton
          hideViolationsFilter
          hideDriversFilter={reportType === reportConstants.REPORT_TYPES.DRIVER}
          selectedFilterData={selectedFilterData}
          terminalCode={selectedFilterData.terminalCode}
        />
      </React.Fragment>
    );
  }
}
export default compose(
  withUserProfile,
  withSnackbar,
  withAppConfig,
)(DriverPerformanceHistoric);
